export function setAccount(state, payload) {
    state.account = payload
}
